/**
 * Asynchronously loads the component for Batch
 */

import { lazyLoad } from 'utils/loadable';

export const VirtualTesterMonitor = lazyLoad(
  () => import('./index'),
  module => {
    return module.VirtualTesterMonitor;
  },
);
